<app-header></app-header>
<app-sidebar></app-sidebar>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="false">
  <p style="color: white"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<div class="content-wrapper">
  <div class="card">
    <div class="card-header bg-success">รายการข้อมูล อ้อยเข้าหีบ {{year.desc}}</div>

    <div class="row justify-content-md-center">
      <div class="col-md-auto">
        <div class="position-relative" style="min-width: 320px;">
          <div class="input-group mb-3">
            <span class="input-group-text" id="input-fm">เลือกชาวไร่</span>
            <input type="text" [(ngModel)]="params_like1.search" (input)="LoadDataLike1()" class="form-control"
              placeholder="Search..." />
            <button *ngIf="params_like1.search.length>0" class="btn btn-outline-secondary"
              (mousedown)="params_like1.search=''">✕</button>
          </div>

          <div *ngIf="data_list.length>0 && params_like1.search.length>0" class="list-group position-absolute w-100"
            style="z-index: 1000; top: 100%; max-height: 320px; overflow-y: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.2);">
            <button type="button" *ngFor="let item of data_list; let i = index" (click)="selectOption(item,0)"
              class="list-group-item list-group-item-action">
              [{{ item.fmcode }}] ชื่อ:{{ item.fmname }}, โซน:{{ item.SUPZONE}}
            </button>
          </div>
        </div>
        <mat-progress-bar *ngIf="loading[0]" mode="indeterminate"></mat-progress-bar>
      </div>
      <div class="col-md-auto" *ngIf="farmerplantlist != null">
        <b>ชื่อชาวไร่ : {{fmname}} </b>
      </div>
      <div class="col-lg-auto" *ngIf="farmerplantlist != null">
        <mat-form-field class="example-full-width" style="text-align:center">
          <input matInput [(ngModel)]="text_f" placeholder="คำค้นหา" style="text-align:center">
          <button *ngIf="text_f" matSuffix mat-icon-button aria-label="Clear" (click)="text_f=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <!-- Button trigger modal -->

    <div class="card-body table-responsive p-2">
      <table #tb_data class="table table-hover table-striped table-head-fixed table-bordered table-sm">
        <thead>
          <tr class="headText text-primary" style="text-align:center">
            <th>#</th>
            <th>วันที่ชั่งออก</th>
            <th>รอบ/คิว</th>
            <th>เลขใบคิว</th>
            <!--<th>โควตา</th>-->
            <th>เลขแปลง</th>
            <th>พื้นที่</th>
            <th>โซน</th>
            <th>กลุ่มตัด</th>
            <th>ประเภทคิว</th>
            <th>ทะเบียน</th>
            <th>ประเภทอ้อย</th>
            <th class="text-center">อ้อยเข้า</th>
            <th class="text-center">CCS</th>
            <th>Action</th>
            <th>หมายเหตุ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of farmerplantlist | filter:text_f;; index as i" style="text-align:center">
            <td scope="row">{{i+1}}</td>
            <td>{{date2th(item.date_in)}}</td>
            <td>{{item.ref_doc1}}/{{item.q_id}}</td>
            <td>{{item.truck_q}}</td>
            <!--<td>{{item.FMCODE}}</td>-->
            <td>{{item.landno}}</td>
            <td>{{item.landvalue}}</td>
            <td>{{item.supzone}}</td>
            <td>{{item.groupcode}}</td>
            <td>{{item.qdesc}}</td>
            <td>{{item.regtruck}}</td>
            <td>{{item.cane_name}}</td>
            <td style="text-align:right">{{item.wgt_net|number}}</td>
            <td style="text-align:right">{{item.ccs_value|number}}</td>
            <td><button class="btn btn-sm btn-info" (click)="Openmodal(item);"
                [disabled]="!setEdit && supzone!=item.supzone && supzone!=item.supzone_fm">แก้ไขข้อมูล</button>
            </td>
            <td style="text-align:left"><textarea class="form-control" cols="9" rows="1" [value]="item.note" disabled
                *ngIf="item.note"></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="Editdata" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" *ngIf="dataoneedit.truck_q">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">แก้ไขแปลงเข้าหีบ</h3>
        <button type="button" class="btn btn-close" (click)="Closemodal();">X</button>
      </div>
      <div class="modal-body">
        <p class="mb-1">หมายเลขแปลงเดิม : <strong>{{dataoneedit.landno}}</strong></p>
        <p class="mb-3">ใบคิว : <strong>{{dataoneedit.truck_q}}</strong> , น้ำหนัก:
          <strong>{{dataoneedit.wgt_net}}</strong>
        </p>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">หมายเลขแปลงเดิม</span>
          <input type="text" class="form-control" [(ngModel)]="plantoneedit" disabled>

        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">หมายเลขแปลงใหม่</span>
          <select class="form-select" [(ngModel)]="dataoneedit.area_id_e">
            <option [ngValue]="null" disabled>กรุณาเลือก</option>
            <option *ngFor="let item of dataplantfarmaer" [ngValue]="item.area_id">
              {{item.intlandno}}, พื้นที่:{{item.landvalue}}, ประเภทอ้อย:{{item.canetype}}
            </option>
          </select>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">ต้องระบุหมายเหตุ</span>
          <textarea class="form-control" [(ngModel)]="dataoneedit.note_e"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="Closemodal();">Close</button>
        <button type="button" class="btn btn-primary"
          [disabled]="!dataoneedit.note_e?.length || dataoneedit.area_id_e===dataoneedit.area_id"
          (click)="SaveData()">บันทึกข้อมูล</button>
      </div>
    </div>
  </div>
</div>


<app-footer></app-footer>